import { createFileRoute } from '@tanstack/react-router';
import { OverviewPage } from '@/features/organizer/pages/OverviewPage';

export const Route = createFileRoute('/_authed/org/$organizationId/')({
  staticData: { help: 'overview' },
  component: OverviewPage,
});
